import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'

function FilterVat(props) {

    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleGroup = (e, val) => {
        e.preventDefault()

        props.handleSearch('group', val)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleClearFilters = () => {
        props.handleSearch('start', '')
        props.handleSearch('end', '')
    }

    return (
        <form className="filter-standard schedule-filter">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>

                    <option value="1">
                        {trans('filters.startDate')}
                    </option>
                    <option value="2">
                        {trans('filters.endDate')}
                    </option>

                </select>
            </div>

            <div className="col" data-id="1">
                <DateRange
                    startDate={props.filter.start}
                    endDate={props.filter.end}
                    onStartDateChange={(date) => {
                        props.handleSearch('start', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('end', date)
                    }}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    Изчистване
                </button>
            </div>
        </form>
    )
}

export default React.memo(FilterVat, (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next)
})